'use strict';

angular.module('TurneroApp').service('monitorService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Monitor', {  }, {
        GetRedisConnect: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Monitor/RedisConnect/',
        },
        VerificacionServidores: {
        	method: 'GET',
        	url: portal.getUrlServer() + 'api/Monitor/VerificacionServidores/',
        	isArray: true
        },
        GetConexiones: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/Monitor/Conexiones/'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/monitor/monitorService.js